import './styles.scss'
import '../accordion-item/styles.scss'

const AKK_CLASS = '.dhsv-akkordeon'

document.addEventListener(
  'DOMContentLoaded',
  function () {
    const akkordeons = Array.from(document.querySelectorAll(AKK_CLASS))
    akkordeons.forEach(handleAkkordeon)
    //console.log({ akkordeons }) //eslint-disable-line
  },
  false
)

const handleAkkordeon = item => {
  const props = JSON.parse(item.getAttribute('data-props'))
  const children = Array.from(item.querySelectorAll(`${AKK_CLASS}--item`))
  const allOpenButton = item.querySelector(`button.show-all-button`)
  let state = children.map((x, i) => i === parseInt(props.selected))

  const renderState = () => {
    children.forEach((child, key) => {
      if (state[key]) {
        child.classList.add('open')
        child.setAttribute('aria-expanded', true)
      } else {
        child.classList.remove('open')
        child.setAttribute('aria-expanded', false)
      }

      animateHeight(child, state[key])
      if (allOpenButton) {
        renderAllOpenButton()
      }
    })
  }

  const renderAllOpenButton = () => {
    const allClosed = !state.includes(true)
    const text = allOpenButton.getAttribute(
      allClosed ? 'data-open' : 'data-close'
    )
    allOpenButton.querySelector(':scope > span').innerHTML = text
    if (!allClosed) {
      allOpenButton.classList.add('open')
    } else {
      allOpenButton.classList.remove('open')
    }
  }

  const animateHeight = (child, open = true) => {
    const body = child.querySelector(`${AKK_CLASS}--item__body`)
    body.style.transition = 'height 0.25s ease'
    const height = body.querySelector(`:scope > div`).clientHeight

    if (open) {
      body.style.height = `${height}px`
      setTimeout(() => {
        body.style.height = 'auto'
      }, 250)
    } else if (parseFloat(body.style.height) !== 0) {
      body.style.transition = 'none'
      body.style.height = height + 'px'
      body.style.transition = 'height 0.25s ease'
      setTimeout(() => {
        body.style.height = 0
      }, 50)
    }
  }

  const handleChildClick = (child, key) => {
    state = state.map((x, i) => {
      const isThisOpen = x && key === i
      // eslint-disable-next-line no-nested-ternary
      return isThisOpen
        ? false
        : // eslint-disable-next-line no-nested-ternary
        props.onlyOne
        ? i === key
        : !x
        ? i === key
        : x
    })
    renderState()
  }

  const handleShowAll = () => {
    state = state.map(() => !allOpenButton.classList.contains('open'))
    renderState()
  }

  renderState()
  children.forEach((child, key) => {
    child
      .querySelector('.item-header')
      .addEventListener('click', () => handleChildClick(child, key))
  })

  if (allOpenButton) {
    allOpenButton.addEventListener('click', handleShowAll)
  }
}
